import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import TreesShrubsFlashImages from "./TreesShrubsFlashImages";

class TreesShrubs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treesshrubspage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "treesShrubs",
    }).then((entries) => {
      this.setState({ treesshrubspage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(treeShrubsDescription) {
    return {
      __html: marked(treeShrubsDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.treesshrubspage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.treesshrubspage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.treeShrubsTitle}</h1>
                    <h2 className="lead">{item.fields.treeShrubsShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.treeShrubsImg.fields.file.url}
                          alt="premier garden care"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.treeShrubsDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      <div className="pt-4">
       <Link to="/trees-shrubs-gallery"><TreesShrubsFlashImages/></Link>
      </div>
      </div>

      </>
    );
  }
}

export default TreesShrubs;
